import React from "react";
import { Calendar, CalendarProps } from "@progress/kendo-react-dateinputs";

/** Custom popup který řeší přetečení šířky kalendáře na malých (šířka < 390px) zařízeních. */
export default function CustomCalendar(props: CalendarProps) {
    return <Calendar {...props} navigation={document.body.clientWidth >= 390} />;
}
